import React, { Component } from 'react';
import styles from './AccordionSection.scss';


class AccordionSection extends Component {

  state = {
    open: false,
    class: styles.accordionSection
  }


  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if(prevProps.globalState !== this.props.globalState){
      if(this.props.globalState == 'closed'){
        this.setState({
          open: false,
          class: styles.accordionSection
        });
      }else{
        this.setState({
          open: true,
          class: styles.accordionSection + ' ' + styles.open
        });
      }
    }
  }

  handleClick= () => {
    if(this.state.open) {
      this.setState({
        open: false,
        class: styles.accordionSection
      });
    }else{
      this.setState({
        open: true,
        class: styles.accordionSection + ' ' + styles.open
      });
    }
  }


  render() {
    let classNames = this.state.class;

    if(this.props.theme == "total"){
      classNames = classNames + ' ' + styles.isTotal;
    }
    if(this.props.theme == "totalDouble"){
      classNames = classNames + ' ' + styles.isTotalDouble;
    }

     if(this.props.children){
        return(   <div className={classNames}>
                    <h1 className={styles.title} onClick={this.handleClick}>{this.props.title}<span>{this.props.titleValue}</span></h1>
                    <div className={styles.accordionContent}>
                       {this.props.children}
                    </div>
                  </div>)
     }else{
        return(   <div className={classNames + ' ' + styles.notExpandable}>
                    <h1 className={styles.title}>{this.props.title}<span>{this.props.titleValue}</span></h1>
                  </div>)
     }
  }
}

export default AccordionSection



// WEBPACK FOOTER //
// ./src/components/atoms/AccordionSection/index.js